/**
 * WCO-3286 — readable before/after audit state (label/value, changed-field highlight).
 */
import React from 'react';
import { buildAuditDiffRows } from './adminActivityStateDiffUtils';

interface AdminActivityStateDiffProps {
  before: Record<string, unknown> | null;
  after: Record<string, unknown> | null;
  t: (key: string) => string;
}

const AdminActivityStateDiff: React.FC<AdminActivityStateDiffProps> = ({ before, after, t }) => {
  const rows = buildAuditDiffRows(before, after, t);

  if (rows.length === 0) {
    return (
      <p className="text-sm text-gray-500 dark:text-gray-400">{t('adminActivity.noFieldChanges')}</p>
    );
  }

  return (
    <ul className="space-y-2 text-sm">
      {rows.map((row) => (
        <li
          key={row.key}
          className={
            row.changed
              ? 'rounded-md border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-900/20 px-3 py-2'
              : 'px-3 py-1'
          }
        >
          <span className="font-medium text-gray-700 dark:text-gray-300">{row.label}: </span>
          {row.beforeDisplay != null && row.afterDisplay != null ? (
            <span className="text-gray-900 dark:text-gray-100">
              {row.changed ? (
                <>
                  <span className="text-gray-600 dark:text-gray-400">{row.beforeDisplay}</span>
                  <span className="mx-1 text-amber-700 dark:text-amber-300">→</span>
                  <span className="font-medium">{row.afterDisplay}</span>
                </>
              ) : (
                row.afterDisplay
              )}
            </span>
          ) : row.afterDisplay != null ? (
            <span className="text-gray-900 dark:text-gray-100">{row.afterDisplay}</span>
          ) : (
            <span className="text-gray-900 dark:text-gray-100">{row.beforeDisplay}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export default AdminActivityStateDiff;
